/*
* Copyright (C) Regione Lombardia
*/
export enum FormDataSessionEnum {
    OPERA_APPROVA = 'OPERA_APPROVA',
    OPERA_RICERCA = 'OPERA_RICERCA',
    PROGETTO_RICERCA = 'PROGETTO_RICERCA',
    RILIEVO_RICERCA = 'RILIEVO_RICERCA',
    UTENTE_RICERCA = 'UTENTE_RICERCA',
    ANAGRAFICA_RICERCA = 'ANAGRAFICA_RICERCA'
}
